import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent/session", { session_id: m[1] });
        // Also store as bearer for cross-origin cookie fallback
        if (data.session_token) localStorage.setItem("outlawd_token", data.session_token);
        await refresh();
        toast.success("Signed in with Google");
        window.history.replaceState({}, "", "/");
        nav("/");
      } catch (err) {
        console.error("Emergent Google login failed", err);
        toast.error("Google login failed");
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return <div className="p-16 text-center font-mono-b" data-testid="auth-callback">Signing you in...</div>;
}
